module.exports = __webpack_public_path__ + "img/work_driving.0fb37105.svg";